import { render, staticRenderFns } from "./SQLRunner.vue?vue&type=template&id=54de89c7&"
import script from "./SQLRunner.vue?vue&type=script&lang=js&"
export * from "./SQLRunner.vue?vue&type=script&lang=js&"
import style0 from "./SQLRunner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VTreeview})
